export const ZODIAC_SIGNS = [
  {
    name: 'Aries',
    symbol: '♈',
    dateRange: 'Mar 21 - Apr 19',
    element: 'Fire',
    color: '#FF6B6B'
  },
  {
    name: 'Taurus',
    symbol: '♉',
    dateRange: 'Apr 20 - May 20',
    element: 'Earth',
    color: '#4ECDC4'
  },
  {
    name: 'Gemini',
    symbol: '♊',
    dateRange: 'May 21 - Jun 20',
    element: 'Air',
    color: '#45B7D1'
  },
  {
    name: 'Cancer',
    symbol: '♋',
    dateRange: 'Jun 21 - Jul 22',
    element: 'Water',
    color: '#96CEB4'
  },
  {
    name: 'Leo',
    symbol: '♌',
    dateRange: 'Jul 23 - Aug 22',
    element: 'Fire',
    color: '#FFEAA7'
  },
  {
    name: 'Virgo',
    symbol: '♍',
    dateRange: 'Aug 23 - Sep 22',
    element: 'Earth',
    color: '#DDA0DD'
  },
  {
    name: 'Libra',
    symbol: '♎',
    dateRange: 'Sep 23 - Oct 22',
    element: 'Air',
    color: '#FFB6C1'
  },
  {
    name: 'Scorpio',
    symbol: '♏',
    dateRange: 'Oct 23 - Nov 21',
    element: 'Water',
    color: '#8B4513'
  },
  {
    name: 'Sagittarius',
    symbol: '♐',
    dateRange: 'Nov 22 - Dec 21',
    element: 'Fire',
    color: '#FF8C00'
  },
  {
    name: 'Capricorn',
    symbol: '♑',
    dateRange: 'Dec 22 - Jan 19',
    element: 'Earth',
    color: '#708090'
  },
  {
    name: 'Aquarius',
    symbol: '♒',
    dateRange: 'Jan 20 - Feb 18',
    element: 'Air',
    color: '#00CED1'
  },
  {
    name: 'Pisces',
    symbol: '♓',
    dateRange: 'Feb 19 - Mar 20',
    element: 'Water',
    color: '#9370DB'
  }
];

export const HOROSCOPE_DATA = {
  aries: {
    today: "Today brings new opportunities for leadership, Aries. Your natural charisma will attract positive attention from colleagues and friends. Take initiative in that project you've been considering - the stars are aligned in your favor. Financial matters look promising, but avoid impulsive decisions.",
    yesterday: "Yesterday was about reflection and planning. You may have felt some resistance to change, but this was necessary for your growth. Your intuition was heightened, helping you navigate through some complex situations.",
    tomorrow: "Tomorrow will be a day of action and movement. You'll feel energized and ready to tackle challenges head-on. A surprise encounter could lead to an exciting new connection or opportunity.",
    yearly: "2026 brings significant personal growth for Aries. Career advancements are on the horizon, particularly in the first half of the year. Relationships will require attention and nurturing. Financial stability improves after mid-year. Travel opportunities may present themselves in the fall."
  },
  taurus: {
    today: "Patience is your greatest asset today, Taurus. While others rush around, your steady approach will win the day. Financial matters look particularly favorable - consider long-term investments rather than quick gains.",
    yesterday: "Yesterday focused on security and comfort. You may have found yourself evaluating your long-term goals and making practical decisions about your future. Your grounded nature served you well.",
    tomorrow: "Tomorrow brings opportunities for creative expression. Your artistic side will flourish, bringing joy and possibly financial rewards. A romantic connection could deepen.",
    yearly: "2026 is a year of building foundations for Taurus. Home and family matters take center stage. Career growth is steady but requires persistence. Financial investments made early in the year will pay off significantly by year-end."
  },
  gemini: {
    today: "Communication flows effortlessly today, Gemini. Your wit and charm will open doors in both personal and professional spheres. It's an excellent day for networking, presentations, or important conversations.",
    yesterday: "Yesterday was about gathering information and making connections. You likely found yourself in multiple conversations, learning new things and expanding your social circle.",
    tomorrow: "Tomorrow brings mental stimulation and variety. You'll juggle multiple tasks successfully. A surprise message or call could bring exciting news or opportunities.",
    yearly: "2026 offers Gemini abundant opportunities for learning and growth. Travel is highlighted, especially in spring and summer. Career changes may occur, leading to more fulfilling work. Relationships flourish through open communication."
  },
  cancer: {
    today: "Your emotional intelligence shines today, Cancer. Trust your intuition when making decisions. Family matters may require your attention, but your nurturing nature will help resolve any issues.",
    yesterday: "Yesterday was about emotional processing and healing. You may have needed time alone to reconnect with your feelings and recharge your emotional batteries.",
    tomorrow: "Tomorrow brings opportunities to nurture others and yourself. Your home environment will be particularly harmonious. A creative project could bring deep satisfaction.",
    yearly: "2026 focuses on home and family for Cancer. Moving or renovating is possible. Career opportunities may require relocation or travel. Emotional growth leads to stronger, more authentic relationships."
  },
  leo: {
    today: "Your natural leadership qualities are amplified today, Leo. Step into the spotlight with confidence. Your generosity and warmth will attract positive energy and opportunities. Creative projects receive cosmic support.",
    yesterday: "Yesterday was about self-expression and recognition. You may have received praise or acknowledgment for your recent efforts. Your confidence was likely at an all-time high.",
    tomorrow: "Tomorrow brings opportunities for romance and creativity. Your magnetic personality will draw others to you. A social event could lead to meaningful connections.",
    yearly: "2026 is a year of expansion and success for Leo. Career advancement is strongly indicated, with leadership roles becoming available. Romantic relationships flourish. Financial gains come through creative ventures."
  },
  virgo: {
    today: "Attention to detail serves you well today, Virgo. Your analytical mind will help you solve problems that others overlook. Health matters improve with small, consistent lifestyle changes.",
    yesterday: "Yesterday focused on organization and efficiency. You likely found great satisfaction in bringing order to chaos. Your practical approach helped others around you.",
    tomorrow: "Tomorrow brings opportunities for service and healing. Your skills will be in high demand. A learning opportunity could enhance your professional value.",
    yearly: "2026 emphasizes personal growth and skill development for Virgo. Career advancement comes through specialized knowledge. Health improvements lead to increased energy and vitality. Relationships deepen through acts of service."
  },
  libra: {
    today: "Balance and harmony are your keywords today, Libra. Your diplomatic skills will be needed to mediate a situation. Artistic pursuits bring joy and possibly recognition. Partnerships thrive under current cosmic influences.",
    yesterday: "Yesterday was about relationships and fairness. You may have found yourself playing the role of mediator or peacekeeper. Your sense of justice helped resolve conflicts.",
    tomorrow: "Tomorrow brings social opportunities and creative inspiration. Your charm will be at its peak. A collaboration could lead to successful outcomes.",
    yearly: "2026 focuses on partnerships for Libra. Both business and personal relationships deepen and strengthen. Creative projects receive recognition. Financial improvements come through joint ventures."
  },
  scorpio: {
    today: "Your intuition is particularly sharp today, Scorpio. Trust your gut feelings about people and situations. Transformation is in the air - embrace change rather than resisting it. Financial opportunities may arise from unexpected sources.",
    yesterday: "Yesterday was about depth and intensity. You may have uncovered hidden truths or had profound insights. Your passion and determination helped you overcome obstacles.",
    tomorrow: "Tomorrow brings opportunities for research and investigation. Your ability to see beneath the surface will serve you well. A powerful connection could form.",
    yearly: "2026 is a year of transformation for Scorpio. Career changes lead to greater empowerment. Relationships evolve to deeper levels. Financial transformation occurs through smart investments and strategic decisions."
  },
  sagittarius: {
    today: "Adventure calls to you today, Sagittarius. Your optimistic outlook will inspire others. Travel or learning opportunities may present themselves. Your philosophical nature helps you see the bigger picture.",
    yesterday: "Yesterday was about exploration and freedom. You likely felt a strong desire to expand your horizons, whether through travel, learning, or new experiences.",
    tomorrow: "Tomorrow brings opportunities for growth and expansion. Your enthusiasm will be contagious. A chance encounter could lead to an exciting new direction.",
    yearly: "2026 offers Sagittarius abundant opportunities for travel and learning. Career expansion may involve international connections. Personal growth comes through embracing new experiences and perspectives."
  },
  capricorn: {
    today: "Your disciplined approach pays off today, Capricorn. Hard work leads to recognition and advancement. Long-term planning yields positive results. Your reliability makes you the go-to person for important projects.",
    yesterday: "Yesterday focused on structure and responsibility. You likely found yourself taking charge of situations and ensuring things were done properly. Your dedication was evident to all.",
    tomorrow: "Tomorrow brings opportunities for leadership and achievement. Your practical wisdom will guide others. Career advancement is strongly indicated.",
    yearly: "2026 is a year of achievement for Capricorn. Career advancement reaches new heights. Financial security strengthens through careful planning. Personal growth comes through embracing change while maintaining your core values."
  },
  aquarius: {
    today: "Your innovative thinking shines today, Aquarius. Your unique perspective will help others see problems in new ways. Social causes and humanitarian efforts benefit from your involvement. Technology and communication are highlighted.",
    yesterday: "Yesterday was about originality and independence. You likely found yourself thinking outside the box and challenging conventional wisdom. Your progressive inspired others.",
    tomorrow: "Tomorrow brings opportunities for collaboration and innovation. Your group-oriented approach will solve complex problems. A social movement or cause may call to you.",
    yearly: "2026 emphasizes community and innovation for Aquarius. Career opportunities arise through networking and technology. Friendships deepen and expand. Humanitarian efforts bring personal fulfillment."
  },
  pisces: {
    today: "Your compassionate nature is heightened today, Pisces. Creative and spiritual pursuits bring deep satisfaction. Trust your artistic intuition - it will guide you to beautiful expressions. Empathy helps you connect deeply with others.",
    yesterday: "Yesterday was about intuition and dreams. You may have received important insights through meditation, dreams, or quiet reflection. Your sensitivity was a gift rather than a burden.",
    tomorrow: "Tomorrow brings opportunities for healing and creativity. Your artistic abilities will flourish. A spiritual connection may deepen, bringing peace and understanding.",
    yearly: "2026 is a year of spiritual and creative growth for Pisces. Artistic projects receive recognition. Relationships deepen through emotional intimacy. Personal transformation leads to greater authenticity and fulfillment."
  }
};
